// extracted by mini-css-extract-plugin
export default {"form":"OVDGRsVK-5qO2w_RfqUYN","heading":"VQXlaqKeT4iFgAs0nKP_u","submitPurple":"_2wlPXs-K3wfPS_zrsNosCI"};